import React from 'react';
import EvaluatorPaymentsBaseTab from './EvaluatorPaymentsBaseTab';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import EvaluatorPaymentsSearchParams from './EvaluatorPaymentsSearchParams';
import EvaluatorPaymentReviewItem from '../../../../Domain/EvaluatorPaymentReviewItem';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';

export default class PendingReviewTab extends EvaluatorPaymentsBaseTab {
  constructor(props) {
    super(props);
    EvaluatorPaymentReviewItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  getType() {
    return 'pending_review';
  }

  renderActionButtons() {
    const disabled = !this.state.itemList.find((il) => il.Selected);
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa-regular fa-xmark',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'Void'
              ),
            tooltip: 'Void',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: disabled,
          },
          {
            iconName: 'fa-solid fa-rotate-right',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'VoidAndReissue'
              ),
            tooltip: 'Void & Reissue',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: disabled,
          },
          {
            iconName: 'fa-solid fa-trash',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected).map((il) => il.IeId),
                'VoidAndSupress'
              ),
            tooltip: 'Void & Supress',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: disabled,
          },
        ]}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.popup}
        {this.renderActionButtons()}
        {this.renderPanels()}
        <TabOfDataTable
          type={EvaluatorPaymentReviewItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorPaymentService.GetEvaluatorPayments}
          convertDBItemsFunction={EvaluatorPaymentService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList: itemList })}
          showSearchStrip={true}
          searchParamsType={EvaluatorPaymentsSearchParams}
          clickOnStartSearch={this.startSearch}
          enableUrlPush={false}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          errorCode='PRT98'
        />
      </div>
    );
  }
}
